import RescheduleSession from '../../../guidanceSessions/components/RescheduleSession';

export default function RescheduleSessionScreen() {
    return <RescheduleSession />;
}
